import angular from 'angular';
import uiRouter from 'angular-ui-router';

export class FooterComponent {
  constructor($scope){
    $scope.year = new Date().getFullYear();
  } 
}

FooterComponent.$inject = ['$scope'];

export default angular.module('directives.footer', [])
  .component('footer', {
    template: require('./footer.html'),
    controller: FooterComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/footer/footer.component.js